import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {ChangeDetectorRef,  OnDestroy} from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { getTranslationDeclStmts } from '@angular/compiler/src/render3/view/template';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})


export class HomeComponent implements OnDestroy {

  public show = false;
  cards = [
    {
      title: 'Web development',
     img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTi-uJmxXzbkaEOdJP0zQFbqjYqBqrgYOnbPY76GTw69gTHjjWC&usqp=CAU',
     link: "www.google.com",
     path: 'modal',
     show: true,
     note: 
     ' HTml is a programming language, covered in more detail in the next session,'+
     ' which allows the designer to dictate content, colours and formatting through a text-based script.' +
     
     ' The presentation layer defines the format of a page through styling elements.'+
     ' This will maintain the consistency in the choices of fonts, colours, sizes and page styling.'  
    },
    {
      title: 'ICT',         
      img:'https://3.bp.blogspot.com/-kjewnxRb6OM/Tzzmf2fZOnI/AAAAAAAAAjU/r0HrLVN3BJE/s1600/guide4bankexams_software.jpg',
      link: "www.google.com",
      path: 'hardware',
      show: true,
      note:'The Information Communication Technology syllabus encourages learners to develop lifelong skills,' +
              'focusing on the ability to use common software applications to solve problems, including word processors,'+
              ' spreadsheets, databases, interactive presentation software, web browsers and website design.'
      
    },
     {
      title: 'Computer Science',       
      img: 'https://img.over-blog-kiwi.com/0/64/15/65/20140206/ob_dd97dc_data-storage-devices-19652673.jpg',
      link: "www.google.com",
      path: 'hardware',
      show: true,
      note: 'The syllabus covers Binary and Hexadecimal numbers,Internet and Communication Technology,Logic gates and circuits'+
      'Operating systems and computer architecture,Input and Output Devices,Memory and Storage, High and Low level Programming Languages'+
      'and more.' 
      
    },    
    {
      title: 'Application Software',     
      img: 'https://p0.pxfuel.com/preview/82/290/480/app-application-application-software-applications-royalty-free-thumbnail.jpg',
       link: "www.google.com",
       path: 'hardware',
       show: true,
       note: 'There are 2 types of software - System Software and Application Software.'+
        ' Microsoft Word and PowerPoint are good examples.'+
        'others are Presentation Program (PowerPoint),Database Program (Access),Web Browser (Internet Explorer).'
        
    },
    {
      title: 'System Software',    
       img: 'https://i.ytimg.com/vi/MmOmTcvc3L4/hqdefault.jpg',
      link: "www.google.com",
      path: 'hardware',
      show: true,
      note: 'This type of software includes operating systems and different' +
       'utilities to allow your system to run smoothly. System software often manages the computers resources.'
    },
    {
      title: 'Artificial Intelligence',           
      img: 'https://i2.wp.com/bdtechtalks.com/wp-content/uploads/2019/06/artificial-intelligence-1.jpg?resize=696%2C522&ssl=1',
      link: "www.google.com",
      path: 'hardware',
      show: true,
      note: 'This is focused on creating computer systems that simulate human intelligence.' +
           'examples are game playing,experr systems and robotics.'
    },
    ];
 mobileQuery: MediaQueryList;
  fillerNav = Array.from({length: 10}, (_, i) => `Chapter ${i + 1}`);
  fillerContent = Array.from({length: 10}, () =>` `);
    private _mobileQueryListener: () => void;

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, public router: Router) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  shouldRun = [/(^|\.)plnkr\.co$/, /(^|\.)stackblitz\.io$/].some(h => h.test(window.location.host));

  getRouter(param){
    this.router.navigateByUrl(param)
  }

  public getInfo(card){
    //this.show? this.show = false: this.show = true;
    card.show? card.show = false: card.show = true;
  }
 

}



